import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import mineCraftApi from '../../api/mineCraftApi';
import minecraftUrls from "../../configs/mine_craft/minecraftUrls";
import { DeviceInterface } from '../../store/mine_craft/devicesSlice';
import { uniq } from "../../helpers/ArrayHelpers";

const processStrategy = (value: any) => {
  return {
    ...value,
    url: minecraftUrls.devicePath(value.id)
  };
}

export const devicesEntity = new schema.Entity(
  'devices',
  {},
  {
    processStrategy
  }
);

export const deviceEntity = new schema.Entity(
  'device',
  {},
  {
    processStrategy
  }
);

const fetchDevicesCollection = async (url: string, params: object = {}) => {
  const response    = await mineCraftApi.get(url, { params })
  const normalized  = normalize<
    any,
    {
      devices: { [key: string]: DeviceInterface };
    }
  >(response.data.devices, [devicesEntity]);

  return {
    devices: normalized.entities?.devices || {},
    ids: uniq(normalized.result),
    count: response.data.meta?.total_count
  };
}

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<
    any,
    {
      device: DeviceInterface;
    }
  >(response.data.device, deviceEntity);
  return normalized.entities;
}

export const fetchDevices = createAsyncThunk(
  'devices/fetchDevices',
  async (params: object = {}) => fetchDevicesCollection('/onesky/devices', params)
);

export const fetchDevice = createAsyncThunk(
  'devices/fetchDevice',
  async (id: number | string) => {
    const response = await mineCraftApi.get(`/onesky/devices/${id}`);
    return normalizeInstance(response);
  }
);

export const updateDevice = createAsyncThunk(
  'devices/updateDevice',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/devices/${id}`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const blockDevice = createAsyncThunk(
  'devices/blockDevice',
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await mineCraftApi.patch(`/onesky/devices/${id}/block`, data);
      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
